// extracted by mini-css-extract-plugin
export var children = "styles-module--children--b5ed9";
export var content = "styles-module--content--8102c";